import {AfterViewInit, Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[validation]'
})
export class ValidationDirective implements AfterViewInit, OnChanges{
  @Input('validation') valid: boolean;
  @Input() hoverElement: HTMLElement;
  nativeElement: HTMLElement;
  span: HTMLElement;
  constructor(private elRef: ElementRef) {

  }

  ngAfterViewInit(): void {
    this.nativeElement = this.elRef.nativeElement;
    this.nativeElement = this.nativeElement.tagName === 'INPUT' ? this.nativeElement : this.nativeElement.querySelector('input');
    this.generateLayout();
    setTimeout(() => {
      this.updateNativeElement();
      this.updateSpan();
      this.updateHoverElement();
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.valid) {
      if (changes.valid.isFirstChange()) {
        return;
      }
      this.updateNativeElement();
      this.updateSpan();
      this.updateHoverElement();
    }
  }

  private updateSpan() {
    this.span.className = `p-inputgroup-addon ${this.getSpanClassName()}`;
  }
  private updateNativeElement() {
    if (this.valid) {
      this.nativeElement.classList.add('valid');
      this.nativeElement.classList.remove('error');
    } else {
      this.nativeElement.classList.add('error');
      this.nativeElement.classList.remove('valid');
    }
  }

  private getSpanClassName(): string {
    switch (this.valid) {
      case true: {
        return 'valid pi pi-check-circle';
      }
      case false: {
        return 'error pi pi-times-circle';
      }
      case undefined: {
        return 'valid';
      }
    }
  }


  private generateLayout() {
    const parent = this.nativeElement.parentElement;
    if (!parent) {
      return;
    }
    const newParent = document.createElement('div');
    newParent.className = 'p-inputgroup';

    this.span = document.createElement('span');
    this.updateSpan();

    parent.replaceChild(newParent, this.nativeElement);
    newParent.appendChild(this.nativeElement);
    newParent.appendChild(this.span);

    this.nativeElement.addEventListener('focus', (e) => {
      this.hoverElement.hidden = false;
    });
    this.nativeElement.addEventListener('blur', (e) => {
      this.hoverElement.hidden = true;
    });
    document.body.appendChild(this.hoverElement);
    this.adjustHoverElement();
  }

  private adjustHoverElement() {
    this.hoverElement.hidden = true;
    this.hoverElement.className = this.hoverElement.className + ' surface-card shadow-3 p-2 border-round';
    this.hoverElement.style.pointerEvents = 'none';
    this.updateHoverElement();
  }

  private updateHoverElement() {
    const spanPosition = this.nativeElement.getBoundingClientRect();
    const left = spanPosition.left;
    const bottom = spanPosition.bottom;
    const parentPosition = this.nativeElement.parentElement.getBoundingClientRect();
    const parentWidth = parentPosition.width;
    this.hoverElement.style.position = 'absolute';
    this.hoverElement.style.left = left + 'px';
    this.hoverElement.style.top = bottom + 'px';
    this.hoverElement.style.width = parentWidth + 'px';
  }
}
